/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const alignNone = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M19 5.5H5V4h14v1.5ZM19 20H5v-1.5h14V20ZM5 9h14v6H5V9Z" />
	</SVG>
);

export default alignNone;
